export enum HealthDataModelType {
	Observation = 'observations',
	Group = 'group',
	Concept = 'concept',
}
